import * as React from 'react';

import { Print, Audio, TranslateFunction } from '@own-local/ad-utils/lib/types';
import PrintContent from './PrintContent';
import AudioPlayer from './AudioPlayer';

export interface ContactContentProps {
  active: boolean;
  name: string;
  about: string;
  print: Print;
  audio: Audio;
  translateString: TranslateFunction;
  locale: string;
  gamTrackingUrl?: string;
};

const ContactContent = (props: ContactContentProps) => {
  const { active, name, about, print, audio, translateString, locale, gamTrackingUrl } = props;

  return (
    <div
      className={`content-wrapper about ${active && 'content-active'}`}
    >
      { audio && audio.is && (
        <AudioPlayer
          url={audio.url}
          name={name}
        />
      )}
      { (!audio || (audio && !audio.is)) && (
        <PrintContent
          active={active}
          print={print}
          translateString={translateString}
          locale={locale}
          gamTrackingUrl={gamTrackingUrl}
        />
      )}
      <p // TODO: This is not the goal. Fix this.
        dangerouslySetInnerHTML={{ __html: about }} />
    </div>
  );
};

export default ContactContent;
